// LocationSelection.js
import React from "react";
import styles from "./OnboardProject.module.scss";

const LocationSelection = ({
  centers,
  selectedLocation,
  onSelect,
  onComplete,
  onBack,
  loading,
}) => {
  // Safe handling of centers data
  const centersList = Array.isArray(centers) ? centers : [];
  const hasCenters = centersList.length > 0;

  return (
    <div className={styles.stepContainer}>
      <div className={styles.stepHeader}>
        <h1>Select your location</h1>
        <p>Choose the medical centre where you'll see patients</p>
      </div>

      {!hasCenters ? (
        <div className={styles.noCentersMessage}>
          <div className={styles.noCentersIcon}>🏥</div>
          <h3>No Medical Centers Available</h3>
          <p>
            There are no medical centers available for this project at the
            moment.
          </p>
          <p>
            Please contact your administrator or choose a different consultation
            type.
          </p>
        </div>
      ) : (
        <>
          <div className={styles.locationList}>
            {centersList.map((center) => (
              <LocationCard
                key={center.centerID || center.id || Math.random()}
                center={center}
                isSelected={selectedLocation?.centerID === center.centerID}
                onSelect={() => onSelect(center)}
              />
            ))}
          </div>

          <div className={styles.stepActions}>
            <button
              className={styles.backButton}
              onClick={onBack}
              disabled={loading}
            >
              ← Back
            </button>
            <button
              className={styles.nextButton}
              onClick={onComplete}
              disabled={!selectedLocation || loading}
            >
              {loading ? "Completing..." : "Complete Setup →"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const LocationCard = ({ center, isSelected, onSelect }) => {
  return (
    <div
      className={`${styles.locationCard} ${isSelected ? styles.selected : ""}`}
      onClick={onSelect}
    >
      <div className={styles.locationRadio}>
        <div className={styles.radioOuter}>
          {isSelected && <div className={styles.radioInner} />}
        </div>
      </div>
      <div className={styles.locationInfo}>
        <h3>{center.centerName || center.name || "Unnamed Center"}</h3>
        {center.address && (
          <p className={styles.locationAddress}>{center.address}</p>
        )}
      </div>
    </div>
  );
};

export default LocationSelection;
